import { render, staticRenderFns } from "./AddressLivraison.vue?vue&type=template&id=1b7e7e4a&scoped=true&"
import script from "./AddressLivraison.vue?vue&type=script&lang=js&"
export * from "./AddressLivraison.vue?vue&type=script&lang=js&"
import style0 from "./AddressLivraison.vue?vue&type=style&index=0&id=1b7e7e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7e7e4a",
  null
  
)

export default component.exports